import { HttpResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Validators, UntypedFormBuilder } from '@angular/forms';
import { UploadService } from 'src/app/_services/upload.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { UtilsService } from 'src/app/_shared/UtilsService';
import { checkTotalFileSizeExceeded } from 'src/app/_shared/file-validation.utils';
import { RecaptchaEnterpriseService } from 'src/app/_services/recaptcha-enterprise.service';

@Component({
  standalone: false,
  selector: 'app-adryoung-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})


export class AdrYoungRegistrationComponent {

  submitted = false;

  siteKey = environment.recaptchaSiteKey;
  blocked = false;
  isOpen = false;

  requestForm = this.fb.group({
    firstname: ['', [Validators.required, Validators.maxLength(255)]],
    lastname: ['', [Validators.required, Validators.maxLength(255)]],
    jobtitle: ['', [Validators.required, Validators.maxLength(255)]],
    organization: ['', [Validators.required, Validators.maxLength(255)]],
    dateofbirth: ['', [Validators.required, Validators.maxLength(255)]],
    city: ['', [Validators.required, Validators.maxLength(255)]],
    country: ['', [Validators.required, Validators.maxLength(255)]],
    emailc: ['', [Validators.required, this.utilsService.validateEmail, Validators.maxLength(255)]],
    onlineprofile: ['', Validators.maxLength(255)],
    how: ['', Validators.maxLength(255)],
    documents: null
  });

  AMC_LANGUAGE_COOKIE = 'amc_lang'; // WIPO language standard cookie name
  filename: string;
  currentFile: File;
  countryOptions = [];
  temp: any[] = [];
  currentLanguage = this.cookieService.get(this.AMC_LANGUAGE_COOKIE);

  isTotalSizeExceeded = false;

  constructor(private cdr: ChangeDetectorRef, private utilsService: UtilsService,
    private fb: UntypedFormBuilder,
    private uploadService: UploadService, private translate: TranslateService,private cookieService: CookieService, private recaptchaService: RecaptchaEnterpriseService) { }

  ngOnInit() {
    this.recaptchaService.load();
    this.translate.onLangChange.subscribe(() => {
      this.currentLanguage = this.translate.currentLang
      this.countryOptions = this.utilsService.loadCountryOption();
    });
    this.countryOptions = this.utilsService.loadCountryOption();
  }

  ngOnDestroy() {
    this.recaptchaService.unload();
  }

  onFileChange(files: File[]) {
    if (files.length > 0) {
      this.requestForm.get('documents').setValue(files);
      this.isTotalSizeExceeded = checkTotalFileSizeExceeded(files);
    }
  }

  get f() { return this.requestForm.controls; }


  async onSubmit() {
    this.submitted = true;
    if (this.requestForm.invalid || this.isTotalSizeExceeded) { return;  }
    const myFormData = new FormData();
    Object.keys(this.requestForm.controls).forEach((key) => {
      if(key !== 'country') {
        const value = this.requestForm.value[key];
        if (Array.isArray(value) && value.every(v => v instanceof File)) {
            value.forEach(f => myFormData.append(key, f));
        } else {
            myFormData.append(key, value);
        }
      }
    });

    let countryName = await this.utilsService.getCountryByCode(this.requestForm.value['country']);
    myFormData.append('countryCode', this.requestForm.value['country']);
    myFormData.append('country', countryName);
    myFormData.append('language', this.currentLanguage);
    
    try {
      const recaptchaToken = await this.recaptchaService.executeScore('submit_adr_young');
      myFormData.append('g_recaptcha_response', recaptchaToken);
      this.uploadService.submitAdrYoungRegistrationForm(myFormData).subscribe(
        response => {
          if (response instanceof HttpResponse) {
            if (response.status === 201) {
              this.blocked = false;
              this.isOpen = true;
            } else {
              this.blocked = false;
            }
          }
        }, err => {
          this.blocked = false;
        }, () => { this.blocked = false; });
    } catch (e) {
      this.blocked = false;
    }
  }


  removeEle() {
    let elements = document.getElementsByClassName('b-input__multi-select--badge ng-star-inserted');
    while (elements.length > 0) {
      elements[0].parentNode.removeChild(elements[0]);
    }
  }

  closeDialogbox() {
    this.isOpen = false;
    this.submitted = false;
    this.removeEle();
    this.requestForm.reset();
    this.isTotalSizeExceeded = false;
  }


}

